import { useEffect, useState, useRef } from 'react'
import { hebrew } from '../../../const/translation'
import classes from './Search.module.css'
import search from '../../../images/search.png'

function Search({
  searchFixed,
  handleScrollToSection,
  searchTerm,
  setSearchTerm,
  searchResults,
  handleSearch,
  setSearchResults,
}) {
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const searchContainerRef = useRef(null)

  // Autocomplete
  useEffect(() => {
    let timeoutId = setTimeout(() => {
      handleSearch()
    }, 100)

    if (searchTerm === '') clearSearch()
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      // Responsible for searching if autocomplete is not used
      // if (selectedIndex === -1 && searchTerm.trim()) {
      //   handleSearch()
      // }

      if (selectedIndex !== -1) {
        const selectedResult = searchResults[selectedIndex]
        handleScrollToSection(
          selectedResult.component,
          selectedResult.accordionId,
          selectedResult.uniqueId
        )
        clearSearch()
      }
    }

    if (event.key === 'ArrowDown') {
      setSelectedIndex((prevIndex) =>
        prevIndex < searchResults.length - 1 ? prevIndex + 1 : prevIndex
      )
    }

    if (event.key === 'ArrowUp') {
      setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0))
    }
  }

  const handleResultClick = (component, accordionId, uniqueId) => {
    handleScrollToSection(component, accordionId, uniqueId)
    clearSearch()
  }

  const clearSearch = () => {
    setSearchTerm('')
    setSearchResults([])
    setSelectedIndex(-1)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        clearSearch()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    const inputField = document.querySelector(`.${classes.search_bar} input`)
    if (inputField) {
      inputField.addEventListener('keydown', handleKeyPress)
    }

    return () => {
      if (inputField) {
        inputField.removeEventListener('keydown', handleKeyPress)
      }
    }
  }, [searchTerm, searchResults, selectedIndex])

  return (
    <div
      ref={searchContainerRef}
      className={searchFixed ? classes.search_fixed : classes.search_absolute}
      dir="rtl"
    >
      <div className={classes.search_bar}>
        <input
          type="text"
          placeholder="מחפשים משהו?"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <img src={search} alt="search" onClick={handleSearch} />
      </div>

      <ul>
        {searchResults.map(
          ({ component, accordionId, accordionName, uniqueId }, index) => (
            <li
              key={index}
              className={`${classes.search_result} ${
                selectedIndex === index ? classes.selected : ''
              }`}
              onClick={() =>
                handleResultClick(component, accordionId, uniqueId)
              }
            >
              <span className={classes.bold}>{hebrew[component]}</span>
              {accordionName && <span>{accordionName}</span>}
            </li>
          )
        )}
      </ul>
    </div>
  )
}

export default Search
